
export default {
  root: {

  },
  padding: {
    padding: '0 !important'
  }
};
